import { SimpleList } from "@/components/list";

export const OFFERINGS_CONSTANTS = {
  title: "What Makes Our Platform Modern? ",
  list: [
    {
      title: "Threat Intelligence Integration (TII) ",
      content: (
        <SimpleList
          points={[
            "Taps into Sophos and CrowdStrike threat feeds ",
            "Detects risks from exposed services and weak identity configurations ",
            "Enriches posture gaps with threat context ",
          ]}
        />
      ),
    },
    {
      title: "MITRE ATT&CK Framework Mapping",
      content: (
        <SimpleList
          points={[
            "Aligns misconfiguration detection with known attacker TTPs",
            "Improves investigation and response workflows",
            "Enables posture audits and red team validation",
          ]}
        />
      ),
    },
    {
      title: "Attack Surface Management (ASM)",
      content: (
        <SimpleList
          points={[
            "Continuously maps exposed cloud assets",
            "Detects shadow IT, orphaned resources, and third-party misalignments",
            "Helps prioritize cloud risks by exploitability and exposure",
          ]}
        />
      ),
    },
  ],
};
